<template>
    <div class="carrier">
        <van-nav-bar
                fixed
                title="载体选择"
                left-arrow
                @click-left="$router.go(-1)">
        </van-nav-bar>
        <div class="hhb-view">
            <detail-view v-model="info" :attrs="attrs" :opts="opts"/>
        </div>
    </div>
</template>

<script>
    import DetailView from "@/components/detail/index";

    export default {
        name: "carrier",
        components: {DetailView},
        data() {
            return {
                info: {},
                opts: {},
                attrs: [
                    {
                        head: {
                            title: '载体选择'
                        },
                        body: [
                            // {type: 'text', name: 'projectName', title: '项目名称：'},
                            {type: 'text', name: 'subIndustry', title: '所属行业：'},
                            {type: 'text', name: 'landDescription', title: '场地或土地需求描述：'},
                            {
                                type: 'tables', name: 'carrierList', hiddenHead: true, columns: [
                                    {title: '名称', field: 'title'},
                                    {title: '内容', field: 'content'}
                                ]
                            },
                        ]
                    }
                ]
            };
        },
        methods: {
            requestData() {
                this.info = {};
                this.$toast.loading('加载中...');
                this.request({
                    url: "/v1.0/project/getProjectCarrier",
                    method: "get",
                    params: {
                        projectId: this.getId,
                    },
                }).then((res) => {
                    const {landDescription} = res.data;
                    const carrierList = this.getCarrierList(res.data);
                    this.$set(this.info, 'carrierList', carrierList);
                    this.$set(this.info, 'landDescription', landDescription);
                    this.$toast.clear();
                }).catch(() => {
                    this.$toast.clear();
                });
            },
            requestProject() {
                this.request({
                    url: "/v1.0/Clues/getCluesDetail",
                    method: "get",
                    params: {
                        CluesId: this.getId,
                    },
                }).then((res) => {
                    const {projectName, companyName,subIndustry} = res.data || {};
                    this.$set(this.info, 'projectName', projectName);
                    this.$set(this.info, 'companyName', companyName);
                    this.$set(this.info, 'subIndustry', subIndustry);
                }).catch(() => {
                });
            },
            getCarrierList(data) {
                const result = [];
                const {carrierParkLibrary} = data || {};
                const list = carrierParkLibrary || [];
                list.forEach(item => {
                    if (item) {
                        const {
                            parkName,
                            address,
                            location,
                            electricityDescription,
                            parkArea,
                            railwayTraffic,
                            waterResourceDescription,
                            drain
                        } = item;
                        result.push([
                            {title: '名称', content: parkName},
                            {title: '所在地', content: location},
                            {title: '详细地址', content: address},
                            {title: '类型', content: electricityDescription},
                            {title: '面积', content: parkArea},
                            {title: '公共交通', content: railwayTraffic ? '有' : '无'},
                            {title: '铁路交通', content: '无'},
                            {title: '电力', content: electricityDescription},
                            {title: '水资源', content: waterResourceDescription},
                            {title: '排水', content: drain ? '有' : '无'}
                        ]);
                        /*address: "重庆市九龙坡区铝城大道"
                        drain: true
                        electricity: 10
                        electricityDescription: "优"
                        id: 12
                        location: "西彭工业园区"
                        parkArea: "225亩"
                        parkDescription: "225亩"
                        parkName: "西彭工业园区15万平方米"
                        railwayTraffic: true
                        waterResource: 10
                        waterResourceDescription: "优"*/
                    }
                });
                return result;
            }
        },
        computed: {
            getId() {
                return this.$route.query.id;
            }
        },
        created() {
            this.requestData();
            this.requestProject();
        }
    }
</script>

<style lang="scss" scoped>
</style>